var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlarmGray2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lxzsifasea",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.392157 0 0 0 0 0.435294 0 0 0 0 0.486275 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lxzsifasea)",
    transform: "translate(-69.000000, -569.000000) translate(69.000000, 567.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.003 15.5c1.58 0 2.632-1.18 2.684-2.444h2.631c.725 0 1.182-.415 1.182-1.048 0-.738-.607-1.344-1.221-1.91-.496-.455-.594-1.344-.712-2.405-.13-2.392-.894-4.045-2.566-4.651C10.727 2.146 9.983 1.5 9.003 1.5c-.986 0-1.73.646-1.998 1.542-1.678.606-2.442 2.26-2.572 4.65-.111 1.062-.216 1.951-.712 2.406-.607.566-1.221 1.172-1.221 1.91 0 .633.457 1.048 1.188 1.048H6.32c.032 1.238 1.09 2.444 2.683 2.444zm4.636-3.848H4.335v-.072c.215-.184.58-.507.888-.87.43-.514.627-1.568.705-2.786.098-2.464.875-3.334 1.867-3.604.157-.04.248-.112.268-.303.04-.653.392-1.074.94-1.074.542 0 .895.421.934 1.074.02.19.111.263.268.303.992.27 1.77 1.14 1.867 3.604.078 1.218.28 2.272.705 2.786.307.363.647.686.862.87v.072zm-4.636 2.675c-.698 0-1.208-.507-1.253-1.271h2.5c-.032.757-.542 1.271-1.247 1.271z",
    transform: "translate(0.000000, 2.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmGray2);
export default __webpack_public_path__ + "static/media/ic_alarm_gray_2.f1d5f28d0b5c1a759f5bf92b41099adf.svg";
export { ForwardRef as ReactComponent };